<template lang="pug">
div
  Header
  |
  ZohoForm.iframe-container.mb-8
//- div
  Header
  |
  .section-2
    .blocks
      .block
        img(src="/assets/images/contact/job-seeker.webp")
        |
        .block_title 
          span I am candidate and I am looking 
          br
          span for a job in the UK
        |
        .button-wrapper
          NuxtLink(
            class="btn btn-primary w-full" 
            to="https://recruitment.nationbetter.uk/"
            @click="trackClick()"
          ) Fill the Job Seeker form
      |
      .block
        img(src="/assets/images/contact/company.webp")
        |
        .block_title 
          span We are a UK company looking
          br
          span to sponsor international talent
        |
        .button-wrapper
          NuxtLink(class="btn btn-primary w-full" to="/employer") Fill the company form
</template>

<script setup lang="ts">
const { $amplitude } = useNuxtApp();

const trackClick = () => {
  if (!$amplitude) return;
  $amplitude.track('Fill the Job Seeker Form Button Clicked', {
    page: window.location.pathname,
    destination: 'https://recruitment.nationbetter.uk/',
  });
};
</script>

<style lang="sass" scoped>
.section-2
  padding-top: 100px
  padding-bottom: 100px

  p
    color: #034033
    text-align: center
    font-size: 18px
    font-style: normal
    font-weight: 500
    line-height: 135%
    width: 670px
    margin: auto
    padding-bottom: 64px
    padding-top: 32px

.blocks
  display: grid

  .block
    border-radius: 16px
    background: #EBF0E1
    padding: 24px
    padding-bottom: 32px

    &_title
      color: #074033
      font-size: 24px
      font-style: normal
      font-weight: 700
      line-height: 29px
      padding: 39px 0 0 0

    &_icon
      display: flex
      width: 48px
      height: 48px
      padding: 12px
      justify-content: center
      align-items: center
      flex-shrink: 0
      border-radius: 8px
      background: var(--limegreen-200, #B5F23C)

    &_description
      color: #074033
      font-size: 18px
      font-style: normal
      font-weight: 500
      line-height: 26px
      padding-top: 16px

    &_button .btn
      width: 100%

.blocks
  grid-template-columns: repeat(2, 468px)
  justify-content: center
  gap: 22px

.block
  display: flex
  flex-direction: column
  justify-content: space-between

  &_title
    text-align: center
    font-size: 24px
    font-style: normal
    font-weight: 800
    line-height: 29px

  img
    max-width: 233px
    margin-left: auto
    margin-right: auto

  .button-wrapper
    display: flex
    justify-content: flex-start
    margin-top: auto
    margin-top: 56px

@media (max-width: 1024px)
  .section-2 .blocks
    grid-template-columns: 1fr

  .block
    padding: 16px
</style>


<style lang="sass" scoped>
.iframe-container
  display: flex
  justify-content: center

  &:deep(iframe)
    width: 50%
    border-radius: 8px
    height: 1024px

@media (max-width: 1024px)
  .iframe-container
    &:deep(iframe)
      width: 100%
      height: 800px

  .section
    padding-left: 5vw
    padding-right: 5vw
</style>